import { GlobalStyles } from '@mui/material';

import { dsVarDefinitions } from './cssVars';

export const ThemePaletteCssVars = () => {
  return <GlobalStyles styles={{ ':root': dsVarDefinitions }} />;
};
